import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import "@/styles/globals.css";
import { useUserStore } from "../stores/UserStore";
import Joyride, { ACTIONS, EVENTS, ORIGIN, STATUS } from "react-joyride";
import { useEffect, useState } from "react";
import { matchPath, useLocation } from "react-router-dom";

const paths = {
  "/search": "Search",
  "/leads": "Leads",
  "/proposals": "Proposals",
  "/contract/:proposal_id": "ContractChat",
  "/contract/:proposal_id/generate": "ContractGenerationAttachmentForm",
  "/contract/:proposal_id/generate/editor": "ContractGenerator",
  "/generate/:proposal_id/editor": "ContractGenerator",
  "/business_profile": "BusinessProfile",
  "/schedule": "Schedule",
  "/generate": "ContractGenerationUploadForm",
};

function ButtonHelp({ steps }) {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const location = useLocation();
  const [onboardingSteps, setOnboardingSteps] = useState(steps);
  const onboardingPath = useUserStore((state) => state.onboardingPath);
  useEffect(() => {
    if (onboardingPath) {
      const onboardingStep = {
        target: "#main-container",
        content: "Learn more about how to use this page",
        title: "Starter Tutorial",
        placement: "center",
        disableBeacon: true,
      };
      for (const path of onboardingPath) {
        const match = matchPath(path, location.pathname);
        if (match) {
          setOnboardingSteps((prev) => [onboardingStep, ...prev]);

          useUserStore.setState((state) => ({
            searchPageSearchParams: state.onboardingPath.filter(
              (p) => p !== path
            ),
          }));

          setRun(true);
          return;
        }
      }
    }
  }, []);

  const handleJoyrideCallback = (data) => {
    const { action, index, origin, status, type } = data;

    if (action === ACTIONS.CLOSE && origin === ORIGIN.KEYBOARD) {
      // do something
    }

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      // Update state to advance the tour
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    } else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      // You need to set our running state to false, so we can restart if we click start again.
      setRun(false);
      setOnboardingSteps(steps);
    }

    console.groupCollapsed(type);
    console.groupEnd();
  };
  const handleClickStart = () => {
    setStepIndex(0);
    setRun(true);
  };
  return (
    <div className="fixed bottom-5 right-10 flex items-center justify-center">
      <TooltipProvider delayDuration={300}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              onClick={handleClickStart}
              className="rounded-full w-7 h-7 flex items-center justify-center p-0 mb-0"
            >
              ?
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <div className="flex flex-col items-center">
              <p>Click to start page tutorial</p>
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <Joyride
        continuous
        hidecloseButton
        scrollToFirstStep
        showSkipButton
        callback={handleJoyrideCallback}
        stepIndex={stepIndex}
        steps={onboardingSteps}
        styles={{
          overlay: {
            height: document.body.scrollHeight,
            backgroundColor: "hsl(var(--background) / 80%)",
          },
          options: {
            arrowColor: "hsl(var(--background))",
            beaconSize: 5,
            backgroundColor: "hsl(var(--background))",
            primaryColor: "hsl(var(--primary))",
            textColor: "var(--primary-color)",
            zIndex: 1000,
          },
          tooltipTitle: {
            fontSize: 18,
            margin: 0,
            fontWeight: "bold",
            borderBottom: "1px solid hsl(var(--secondary))",
          },

          buttonSkip: {
            borderBottom: "1px solid hsl(var(--secondary))",
            padding: "3px",
            fontWeight: "bold",
            color: "hsl(var(--muted-foreground))",
          },
        }}
        run={run}
      />
    </div>
  );
}

export default ButtonHelp;
